export default __webpack_public_path__ + "static/wet-6bcef7772f1e1b0723b80a6421514645.jpg";